import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";
import { toast } from "sonner";

/** Botão "Atualizar": mostra o ícone girando enquanto recarrega e avisa quando terminou. */
export function RefreshButton({ onClick, variant = "ghost", label = "Atualizar", done = "Lista atualizada.", iconOnly = false, size, className = "" }) {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    if (busy) return;
    setBusy(true);
    const minimo = new Promise((r) => setTimeout(r, 700));
    try { await Promise.all([Promise.resolve(onClick && onClick()), minimo]); toast.success(done); }
    catch (e) { toast.error("Não foi possível atualizar. Tente de novo."); }
    finally { setBusy(false); }
  };
  return (
    <Button variant={variant} size={size} onClick={run} disabled={busy} data-testid="btn-refresh" title={label} className={className}>
      <RefreshCw className={`h-4 w-4 ${iconOnly ? "" : "mr-1.5"} ${busy ? "animate-spin" : ""}`} />{!iconOnly && <> {busy ? "Atualizando…" : label}</>}
    </Button>
  );
}
